import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/api_public/pages/settings/RootPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      handle: {
        responsive: true,
        meta: () => {
          return getSettingPageMeta(navigation, 'api_keys')
        },
      },
      path: navigation.settings.apiKeys.path,
      element: <RootPage />,
    },
  ]
}

export default settingsRoutes
